<template>
  <div>
    <the-nav-bar :title="$t('newSettings.kycVideo.title')"  ref="nav"/>
      <!-- load success -->
    <div class="success-wrapper">
      <!-- 正在审核 -->
      <div class="status-wrapper col-center" v-if="status === 'applied'">
        <img src="@/images/status-waiting.svg" alt="Wait" class="icon" />
        <span class="text">
          {{ $t('newSettings.apply.wait') }}
        </span>
        <span class="subtext">
          {{ $t('newSettings.apply.waitInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 审核成功 -->
      <div class="status-wrapper col-center" v-else-if="status === 'adopted'">
        <img src="@/images/status-success.svg" alt="Success" class="icon" />
        <span class="text">
          {{ $t('newSettings.apply.adopted') }}
        </span>
        <span class="subtext">
           {{ $t('newSettings.apply.adoptedInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 未通过 -->
      <div class="status-wrapper col-center" v-else-if="status === 'fail'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
                <span class="text">
          {{ $t('newSettings.apply.fail') }}
        </span>
        <span class="subtext">
        {{ $t('newSettings.apply.failInfo') }}  {{ message }}
        </span>
        <md-button type="primary" @click="goKyc">
          <span>{{ $t('common.reapply') }}</span>
        </md-button>
      </div>

    </div>

    <md-popup  class="inner-popup" v-model="isPopupShow" :mask-closable="true" >
      <md-popup-title-bar
        only-close
        :title="$t('newSettings.kycVideo.title')"
        title-align="left"
        @cancel="hidePopUp()"
      ></md-popup-title-bar>
    <md-field :brief="$t('newSettings.kycVideo.notKeepInfo')" class="body-wrapper">
     <template >
        <md-input-item
          name="nickname"
          type="text"
          v-model.trim="nickname"
          :title="$t('newSettings.kycVideo.nickname')"
          align="right"
          disabled
        ></md-input-item>

        <md-field-item :title="$t('newSettings.kycVideo.videoInfo')" class="upload photos-class" >
          <div  slot="children" class="video-box">

          <label class="upload-icon">
            
            <md-icon name="camera" size="md" color="#CCC"></md-icon>
            <p v-if="video ==null" >{{ $t('newSettings.upload') }}</p>
            <p v-else>{{ $t('newSettings.reUpload') }}</p>
     
            <input type="file" ref="fileInput" @change="handleFileChange" accept="video/*" style="display:none;">
          </label>
            <p v-if="video!==null && video.name">{{ video.name }}</p>

          </div>

         </md-field-item>
                   <p style="color:red;" v-if="fileSizeError">文件大小超过10MB</p>
                   <p style="color:red;"  v-if="fileExtensionError">文件类型不支持</p>  
      </template>

      <div class="field-footer" slot="footer">
        <div class="info">
          {{ $t('newSettings.kycVideo.uploadTips') }}
        </div>
        <div class="info ">
          {{ $t('newSettings.kycVideo.uploadSkill') }}
        </div> 

        <div class="btn-wrapper">
          <md-button
            :type="btnDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <md-activity-indicator
              v-if="isSubmitting"
              type="carousel"
              color="currentColor"
            ></md-activity-indicator>
            <span v-else>{{ $t('common.submit') }}</span>
          </md-button>
        </div>
      </div>
    </md-field>

    </md-popup>

  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Popup,
  PopupTitleBar,
  Field,
  FieldItem,
  InputItem,
  Button,
  ImageReader,
  Icon,
  Tag,
  ActivityIndicator,
  Dialog,
  Toast,
} from 'mand-mobile';
import postUserAdvVideo from '@/api/post-user-kyc-video';
import getUserKycVideo from '@/api/get-user-kyc-video';

export default {
  components: {
    TheNavBar,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [ImageReader.name]: ImageReader,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    Toast,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      isPopupShow: false,
      nickname: '',
      status: '',
      video: null,
      isSubmitting: false,
      isRemoving: false,
      btnDisabled: false,
      validate: false,
      fileSizeError: false,
      fileExtensionError: false,
      maxSize: 10485760, // 设置最大文件大小为10MB
      validExtensions: ['.mp4', '.mov', '.avi','.wmv','.3gp'], // 设置要求的视频文件扩展名列表
    };
  },
  computed: {

  },
  created(){

    getUserKycVideo().then(data => 
    {
      const d = data.data;
      this.nickname = d.nickname;
      this.status = d.status;
      this.message = d.message;
      if(this.status ==='no'){
        this.isPopupShow = true;
      }
    }).catch(err => {
      Dialog.alert({
        icon: 'fail',
        title: this.$t('error.occurs'),
        content: err.message,
        confirmText: this.$t('common.confirm'),
      });
      // this.$router.go(-1);
    });
  },
  mounted() {
    
  },
  methods: {
    hidePopUp() {
      this.goBack();
    },
    goKyc() {
      this.isPopupShow =true;
    },
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
    isFileSizeValid(file, maxSize) {
      return file.size <= maxSize;
    },
    isValidVideoFile(filename) {
      const extension = filename.substring(filename.lastIndexOf('.')).toLowerCase();
      return this.validExtensions.includes(extension);
    },
    handleFileChange(event) {
      this.video = event.target.files[0]; // 获取选择的视频文件

      if (!this.isFileSizeValid(this.video, this.maxSize)) {
        this.fileSizeError = true; // 如果文件大小超过限制，则显示错误消息
      } else{
        this.fileSizeError = false; 
      }
      if (!this.isValidVideoFile(this.video.name)) {
        this.fileExtensionError = true; // 如果文件类型不支持，则显示错误消息
      }else{
        this.fileExtensionError = false; 
      }
    },
    onSubmit() {
      if (!this.video) {
        return;
      }
      if(this.fileSizeError || this.fileSizeError){
        Toast.failed('视频不符合要求');
        return;
      }
      this.isSubmitting = true;
      let params = {
        nickname: this.nickname,
        video: this.video,
      };

      postUserAdvVideo(params)
        .then(data => {

          this.isSubmitting = false;
          const d = data.data;
          this.nickname = d.nickname;
          this.status = d.status;
          this.message = d.message;
          if(this.status ==='no'){
            this.isPopupShow = true;
          }else{
            // this.$store.commit('setAdvKycInfo',{
            //   status:this.status,
            //   message: this.message,
            // });
            this.isPopupShow =false;
          }
          
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occurs'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    copy(source, target) {
      Object.entries(source).forEach(([key]) => {
        source[key] = target[key];
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .md-popup
    top: 10vh;
.status-wrapper {
  min-height: 80vw;

  .md-icon, .icon {
    font-size: 16vw;
    width: 16vw;
    height: 16vw;
  }

  .text {
    margin-top: 9.6vw;
    font-size: 4.8vw;
  }

  .subtext {
    margin: 2.13vw 9.6vw 0;
    text-align: center;
  }

  .md-button {
    margin-top: 14.4vw;
    width: 60vw;
  }

}

.body-wrapper {
  padding-bottom: 20vw;

  .md-field-item {
    margin-bottom: 3.2vw;
  }

  & >>> {
    .md-field-item-content {
      height: 17.07vw;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      width: 32vw;
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      width: 53.6vw;
      text-align: right;
    }

    .md-input-item-input {
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      padding: 0 2.67vw;
      background: #f8fbfc;
    }

    .md-field-item-children {
      top: 100%;
      z-index: 10;
      margin-top: 0;
    }
  }

  .upload {
    & >>> {
      .md-field-item-content {
        height: auto;
        align-items: flex-start;
      }

      .md-field-item-title {
        margin-top: 5.33vw;
        width: 40vw;
      }

      .md-field-item-control {
        width: 40vw;
        flex: 0 0 auto;
      }
    }

    .upload-content {
      position: relative;
      box-sizing: border-box;
      margin-top: 2.67vw;
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      height: 40vw;
      background: #f8fbfc;
      color: #BCC7CB;
      overflow: hidden;

      .preview-img {
        width: 100%;
        line-height: 40vw;
        vertical-align: middle;
      }

      .icon {
        width: 14vw;
        height: 14vw;
      }
    }
  }

  .info {
    margin-top: 4.8vw;
    color: #84969c;
  }
  

  .btn-wrapper {
    margin-top: 9.6vw;

    .md-button {
      margin-bottom: 4.8vw;
    }

    & >>> .md-activity-indicator-svg {
      width: 16vw !important;
      height: 4vw !important;
    }
  }
}

.video-box
  display inline-block
  width 100%
  padding-left 0
  height: 17.07vw;
  margin-bottom: 3vw;
.upload-icon
  height: 100%
  position relative
  float left
  width 23.5%
  padding-bottom 23.5%
  margin-right 2%
  background #FFF
  box-shadow 0 5px 20px rgba(197, 202, 213, .25)
  box-sizing border-box
  list-style none
  border-radius 4px
  background-size cover
  >>>.md-icon
    position absolute
    top 40%
    left 50%
    transform translate(-50%, -50%)
    opacity .5
  p
    position absolute
    top 50%
    left 0
    width 100%
    margin-top 15px
    font-size 22px
    color #CCC
    text-align center



.upload-icon input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

</style>
